import { emitShopifyEvent, dialogStack } from "../services/analytics.service";
import { hideOverlay, showOverlay, whenNotShownInOverlay } from './Overlay';
import { TABBABLE_ELEMENT_SELECTOR } from '../services/accessibility.service';
import { INLINE_CART_SHOW, INLINE_CART_CLOSE } from '../constants/events.constants';
import { renderCartContents } from '../helpers/cart.helper';
import { onCartUpdate, cartState } from '../services/cart.service';
export default (($) => {
    console.log('UNTUCKit : Module : InlineCart : loaded');
    const $inlineCart = $('.js-inline-cart');
    const $checkout = $('.js-checkout');
    const $tooltip = $('.js-tooltip');
    const currentCurrency = window.UNTUCKitConfig.cartCurrencySymbol;
    const renderCart = function (cartData) {
        console.log('UNTUCKit : Module : InlineCart : renderCart');
        const $cartContents = $('.js-cart-contents');
        const $nonEmptyCartSections = $('.js-cart-bottom, .js-cart-subtotal');
        if (cartData.items.length) {
            $nonEmptyCartSections.show();
            $checkout.prop('disabled', false);
        }
        else {
            $cartContents.html('<div class="cart-empty">Your Cart is Currently Empty.</div>');
            $nonEmptyCartSections.hide();
            $checkout.prop('disabled', true);
        }
        const $price = $('.js-cart-total-price');
        const $qty = $('.js-cart-qty');
        const $sidecartQty = $('.js-side-cart-qty');
        $qty.html(`${cartData.item_count}`);
        $sidecartQty.html(cartData.item_count ? `(${cartData.item_count} item${cartData.item_count > 1 ? 's' : ''})` : '');
        $price.html(cartData.total_price ? currentCurrency + (cartData.total_price / 100).toFixed(2) : '');
    };
    async function updateCartUI(cartData) {
        console.log('UNTUCKit : Module : InlineCart : updateCart');
        await renderCartContents(cartData);
        if (!isInlineCartShown()) {
            adaHide();
        }
        renderCart(cartData);
    }
    async function show() {
        console.log('UNTUCKit : Module : InlineCart : show');
        $inlineCart.addClass('is-active');
        showOverlay('inline-cart');
        adaShow();
        const cartData = cartState.get();
        if (cartData) {
            emitShopifyEvent("view_cart", cartData);
        }
        dialogStack.push('inline-cart');
    }
    function hide() {
        console.log('UNTUCKit : Module : InlineCart : hide');
        if (isInlineCartShown()) {
            $inlineCart.removeClass('is-active');
            hideOverlay();
            adaHide();
            dialogStack.pop('inline-cart');
        }
    }
    function bindUIActions() {
        console.log('UNTUCKit : Module : InlineCart : bindUIActions');
        $('.js-open-cart').on('click', async function (e) {
            console.log('UNTUCKit : Module : InlineCart : .js-open-cart click');
            e.stopPropagation();
            if (isInlineCartShown()) {
                hide();
            }
            else {
                show();
            }
            return false;
        });
        $('.js-close-cart').on('click', function (e) {
            console.log('UNTUCKit : Module : InlineCart : .js-close-cart click');
            e.stopPropagation();
            hide();
            return false;
        });
        onCartUpdate.subscribe((cart) => updateCartUI(cart));
        window.addEventListener(INLINE_CART_SHOW, () => show());
        window.addEventListener(INLINE_CART_CLOSE, () => hide());
        $('body').on('click', function () {
            $tooltip.next().removeClass('is-active');
        });
        $tooltip.on('click', function () {
            $(this)
                .next()
                .toggleClass('is-active');
        });
        $tooltip.parent().on('click', function (e) {
            e.stopPropagation();
        });
        adaHide();
        whenNotShownInOverlay('inline-cart').subscribe(() => hide());
    }
    function init() {
        console.log('UNTUCKit : Module : InlineCart : init');
        bindUIActions();
        adaHide();
    }
    function adaShow() {
        console.log('UNTUCKit : Module : InlineCart : adaShow');
        $inlineCart.prop('aria-hidden', false);
        $inlineCart.prop('tabindex', 0);
        const $hiddenEls = $inlineCart.find(TABBABLE_ELEMENT_SELECTOR);
        $hiddenEls.each((index, hiddenEl) => {
            $(hiddenEl).prop('aria-hidden', false);
            $(hiddenEl).prop('tabindex', 0);
        });
        $inlineCart.trigger("focus");
    }
    function adaHide() {
        console.log('UNTUCKit : Module : InlineCart : adaHide');
        $inlineCart.prop('aria-hidden', true);
        $inlineCart.prop('tabindex', -1);
        const $visibleEls = $inlineCart.find(TABBABLE_ELEMENT_SELECTOR);
        $visibleEls.each((index, visibleEl) => {
            $(visibleEl).prop('aria-hidden', true);
            $(visibleEl).prop('tabindex', -1);
        });
    }
    function isInlineCartShown() {
        return $inlineCart.hasClass('is-active');
    }
    return { init };
})($);
